<template lang="html">
  <div class="navigation" v-if="open">
    <h2 class="navigation__header">
      <button v-if="showCategory > 0" class="navigation__back" @click="onBack">
        <svg class="bi" width="22" height="22" fill="currentColor">
          <use href="../static/bi-sprite.svg#arrow-left" />
        </svg>
      </button>
      Menu
      <button class="navigation__close" href="#" @click="onClose">
        <svg class="bi" width="21" height="21" fill="currentColor">
          <use href="../static/bi-sprite.svg#x-light" />
        </svg>
      </button>
    </h2>

    <transition name="reveal-lev1">
      <div class="navigation__lev-1" v-if="showCategoryList">
        <ul class="navigation__list">
          <template v-for="item in navigation">
            <navigation-item
              :item="item"
              type="button"
              @click="changeCategory"
            />
          </template>
        </ul>
        <nav class="navigation__help" v-if="help">
          <div class="navigation__label">{{ help.header }}</div>
          <a
            class="navigation__help-link"
            :href="item.url"
            v-for="item in help.links"
          >
            {{ item.title }}
          </a>
        </nav>
        <div class="navigation__service">
          <div class="navigation__label">Øvrige sider og hjælp</div>
          <ul class="navigation__service-list">
            <li class="navigation__service-item">
              <a
                class="navigation__service-link"
                v-if="account && isLoggedIn"
                :href="account.url"
              >
                <div class="navigation__service-icons">
                  <svg class="bi" width="30" height="30" fill="currentColor">
                    <use href="../static/bi-sprite.svg#chef" />
                  </svg>
                  <svg
                    class="bi mt-1 navigation__service-checkmark"
                    width="12"
                    height="12"
                    fill="currentColor"
                  >
                    <use href="../static/bi-sprite.svg#checkmark-circled" />
                  </svg>
                </div>
                {{ account.title }}
              </a>
              <a
                class="navigation__service-link"
                v-else-if="login"
                :href="login.url"
              >
                <svg class="bi" width="30" height="30" fill="currentColor">
                  <use href="../static/bi-sprite.svg#chef" />
                </svg>
                {{ login.title }}
              </a>
            </li>
            <li class="navigation__service-item">
              <a
                class="navigation__service-link"
                v-if="store"
                :href="store.url"
              >
                <svg class="bi" width="30" height="30" fill="currentColor">
                  <use href="../static/bi-sprite.svg#marker" />
                </svg>
                {{ store.title }}
              </a>
            </li>
            <li class="navigation__service-item">
              <a
                class="navigation__service-link"
                v-if="contact"
                :href="contact.url"
              >
                <svg class="bi" width="30" height="30" fill="currentColor">
                  <use href="../static/bi-sprite.svg#contact" />
                </svg>
                {{ contact.title }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </transition>

    <transition name="reveal-lev2">
      <div
        class="navigation__lev-2"
        v-if="showCategory && category"
        :class="{ 'navigation__lev-2--active': useCategoryCssClass }"
      >
        <div
          class="container navigation__content"
          :class="{ open: showCategory }"
        >
          <div class="navigation__wrapper">
            <div class="navigation__label d-none d-lg-block">Kategorier</div>
            <ul class="navigation__list">
              <template v-for="item in category.links">
                <navigation-item :item="item" type="a" />
              </template>
            </ul>
          </div>
          <div class="navigation__teaser" v-if="category.teaser">
            <div class="navigation__label">{{ category.teaser.title }}</div>
            <figure>
              <img
                v-if="category.teaser.image"
                :src="category.teaser.image"
                :alt="category.teaser.title"
              />
              <figcaption>
                <a
                  class="navigation__teaser-link"
                  :href="category.teaser.url"
                  v-if="category.teaser.url"
                  >{{ category.teaser.text }}</a
                >
                <span v-else>{{ category.teaser.text }}</span>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import NavigationItem from "./components/NavigationItem";

export default Vue.extend({
  name: "Navigation",
  components: {
    NavigationItem
  },
  props: [],
  data() {
    return {
      open: false,
      loading: true,
      showCategoryList: true,
      showCategory: false,
      useCategoryCssClass: false,
      navigation: [],
      category: {},
      help: [],
      contact: {},
      account: {},
      login: {},
      store: {},
      isLoggedIn: false
    };
  },
  created() {
    window.addEventListener("header-toggle", this.onNavigationToggle);
    window.addEventListener("navigation-category", this.onCategoryChange);

    axios
      .get("/umbraco/surface/navigation/GetNavigation", {
        params: {
          id: window.umbracoContext.id
        }
      })
      .then((response) => {
        this.loading = false;
        this.navigation = response.data.navigation;
        this.contact = response.data.contact;
        this.store = response.data.store;
        this.account = response.data.account;
        this.login = response.data.login;
        this.help = response.data.help;
        this.isLoggedIn = response.data.isLoggedIn;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    onNavigationToggle(e) {
      this.open = e.detail.navigation;
    },
    onCategoryChange(e) {
      const id = e.detail.categoryId || null;
      this.changeCategory(id);
    },
    onBack() {
      this.showCategoryList = true;
      this.showCategory = false;
    },
    onClose() {
      var event = new CustomEvent("header-toggle", {
        detail: { search: false, navigation: !this.open }
      });
      window.dispatchEvent(event);
    },
    changeCategory(id) {
      this.category = this.navigation.find((x) => x.id === id);
      if (this.category) {
        this.open = true;
        this.showCategoryList = false;
        this.showCategory = true;
        setTimeout(() => {
          this.useCategoryCssClass = true;
        }, 50);
      } else {
        this.showCategoryList = true;
        this.showCategory = false;
        this.open = false;
        this.useCategoryCssClass = false;
      }
    }
  }
});
</script>
